import { use } from "react";
import { useParams } from "react-router";
import { BikeContext } from "../../context/bikeContext";
import { usePreferences } from "../../hooks/useAccount";
import { useInfiniteSettings } from "../../hooks/useSetups";
import HistoryTable from "./HistoryTable";

const History = () => {
  const params = useParams<"setupId">();
  const setupId = String(params.setupId);
  const { data: settings, isPending } = useInfiniteSettings(setupId);
  const { bike } = use(BikeContext);
  const { data: preferences } = usePreferences();

  return (
    <>
      {!isPending && (
        <HistoryTable
          settings={settings}
          bike={bike}
          preferences={preferences}
        />
      )}
    </>
  );
};

export default History;
